export const api = () => {
  switch (location.host) {
    case 'www.gifthorse.io': return 'https://api.gifthorse.io';
    default: return 'https://local.gifthorse.io:8443';
  }
}

export const VAPID_PUBLIC_KEY = 'BDAEHzXNMXOEHvaTDamgxY89ixo3XBfr8CI1GMC_mhO0uBfOguA-VSMZfduJOY5nuNcuF8AKzKnF3o705rxMVwg';

